import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { fetchAsset } from "~/thunks/assetsThunks";
import type { BridgeElement } from "~/types/bridge";
import type { RightClickMenuAction, RightClickMenuPosition, RightClickMenuProps } from "~/types/rightClickMenu";

export interface RightClickMenuState {
  position: RightClickMenuPosition | null;
  title: string;
  actions: RightClickMenuAction[];
  element?: BridgeElement | null;
};

const initialState: RightClickMenuState = {
  position: null,
  title: "",
  actions: [],
  element: null

};

const rightClickMenuSlice = createSlice({
  name: "rightClickMenu",
  initialState,  
  reducers: {
    setPosition: (state, action: PayloadAction<RightClickMenuPosition | null>) => {
      state.position = action.payload;
    },
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setRightClickMenuActions: (state, action: PayloadAction<RightClickMenuAction[]>) => {
      state.actions = action.payload;
    },
    setRightClick: (state, action: PayloadAction<RightClickMenuState>) => {
      const { position, title, actions, element } = action.payload;
      state.position = position;
      state.title = title;

      state.actions = actions;
      state.element = element;
    }
  },
  extraReducers: (builder) => {
    builder  
    .addCase(fetchAsset.pending, (state, action: PayloadAction<any>) => {
            Object.assign(state, initialState);
          })
  },
});

export const { setRightClick, setPosition, setTitle, setRightClickMenuActions } = rightClickMenuSlice.actions;
export const selectRightClickMenu = (state: any) => state.rightClickMenu;
export default rightClickMenuSlice.reducer;